import {
  ActivatedRouteSnapshot,
  NavigationExtras,
  Router
} from "@angular/router";
import { merge } from "lodash-es";
import { RouteTabConfig } from "../components/ui/route-tab/route-tab-config";

export function getLastTabConfig(
  routeSnaphost: ActivatedRouteSnapshot,
  lastTabConfigFound: RouteTabConfig | null = null
): RouteTabConfig | null {
  const tabConfig: RouteTabConfig | null =
    routeSnaphost.data?.tab || lastTabConfigFound || null;

  if (!routeSnaphost.firstChild) {
    return tabConfig;
  }

  return getLastTabConfig(routeSnaphost.firstChild, tabConfig);
}

export function getFirstTabConfig(
  routeSnaphost: ActivatedRouteSnapshot
): RouteTabConfig | null {
  return routeSnaphost.data?.tab || null;
}

export function mergeRouteParams(
  routeSnaphost: ActivatedRouteSnapshot,
  map: Record<string, any> = {}
): Record<string, any> {
  if (routeSnaphost.params) {
    merge(map, routeSnaphost.params);
  }

  if (routeSnaphost.firstChild) {
    return mergeRouteParams(routeSnaphost.firstChild, map);
  }

  return map;
}

export async function sntNavigate(
  router: Router,
  commands: string[],
  extras?: Partial<NavigationExtras>
): Promise<boolean> {
  return await router.navigate(commands, {
    ...(extras || {}),
    replaceUrl: false
  });
}
